<div class="fm">
  <div class="fm-ugyfel">
    <div class="fm-ugyfel-bal">
      <span class="fm-mod ber-mod" title="Adózási forma">{{ aktiv.adozas || (aktiv.kivas ? 'KIVA' : 'TAO') }}</span>
      <h1>{{ aktiv.ugyfelNev }}</h1>
      <span class="fm-ev">{{ aktiv.ev }}. év · {{ honapNev(aktiv.ho) }}</span>
    </div>
    <a class="fm-csere" routerLink="/ber/ugyfelek"><ion-icon name="swap-horizontal-outline"></ion-icon> Másik ügyfél</a>
  </div>

  <!-- TEENDŐK: a megbízottak biztosítotti bejelentése (08E), amit a számfejtés mentése vett fel. -->
  <div class="fm-teendok" *ngIf="teendok.length">
    <div class="fm-teendo-fej"><ion-icon name="alert-circle-outline"></ion-icon> Teendők <span class="fm-teendo-db">{{ teendok.length }}</span></div>
    <div class="fm-teendo" *ngFor="let t of teendok" [class.lejart]="lejart(t)">
      <div class="fm-teendo-szoveg">
        <ng-container *ngIf="t.allapot === 'teendo'">
          <b>{{ t.nev }}</b> megbízottként biztosított lett {{ t.ev }}. {{ honapban(t.ho) }}
          (járulékalap {{ ft(t.jarulekalap) }} Ft ≥ küszöb {{ ft(t.kuszob) }} Ft{{ t.napok < t.honap_napok ? ', ' + t.napok + ' nap' : '' }})
          – <b>08E bejelentés</b> kell ({{ tolIg(t) }})
        </ng-container>
        <ng-container *ngIf="t.allapot === 'visszavonando'">
          <b>{{ t.nev }}</b> {{ t.ev }}. {{ honapNev(t.ho).toLowerCase() }}i biztosítását bejelentetted, de az újraszámfejtés szerint
          <b>nem biztosított</b> (járulékalap {{ ft(t.jarulekalap) }} Ft &lt; {{ ft(t.kuszob) }} Ft) – a 08E-n törölni kell.
        </ng-container>
        <span class="fm-teendo-hatarido" *ngIf="t.hatarido && t.allapot === 'teendo'">határidő: {{ t.hatarido | date:'yyyy.MM.dd' }}</span>
      </div>
      <div class="fm-teendo-gombok">
        <ion-button size="small" fill="outline" (click)="nyit08E(t)"><ion-icon slot="start" name="document-text-outline"></ion-icon>08E</ion-button>
        <ion-button size="small" fill="clear" (click)="kesz(t)" [title]="t.allapot === 'teendo' ? 'A 08E-t beadtam' : 'A törlést beadtam'"><ion-icon slot="start" name="checkmark-outline"></ion-icon>Beadva</ion-button>
      </div>
    </div>
  </div>

  <!-- FŐMENÜK -->
  <div class="fm-fomenuk">
    <button *ngFor="let x of menuk" type="button" class="fm-fomenu" [class.aktiv]="valasztott === x.f.kulcs" (click)="valaszt(x.f.kulcs)">
      <ion-icon [name]="x.f.ikon"></ion-icon>
      <span><u>{{ x.f.cim[0] }}</u>{{ x.f.cim.slice(1) }}</span>
    </button>
  </div>

  <div class="fm-elvalaszto"></div>

  <!-- A kiválasztott főmenü pontjai -->
  <div class="fm-csempek">
    <button *ngFor="let p of pontok" type="button" class="fm-csempe" (click)="nyit(p)">
      <ion-icon [name]="p.ikon"></ion-icon>
      <span class="fm-csempe-cim">{{ p.cim }}</span>
      <span class="fm-csempe-leiras">{{ p.leiras }}</span>
    </button>
  </div>

  <div class="ures" *ngIf="!menuk.length">
    <ion-icon name="lock-closed-outline"></ion-icon>
    Ehhez az intézményhez nincs egyetlen bérszámfejtési képernyőre sem jogosultságod.
  </div>

  <p class="fm-sugo">Tipp: a főmenük a fejlécből is nyithatók, billentyűzettel <b>{{ modBillNev }} + az aláhúzott betű</b>.</p>
</div>
